import React, { FunctionComponent, useState, useMemo } from "react"
import { unstable_batchedUpdates } from "react-dom"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import Loader from "../../../components/Loader/Loader"
import Seo from "../../../components/Seo/Seo"
import { iAccess } from "../../../definitions/Access"
import {
  iResponse,
  iIdParams,
  iInspectorProps,
} from "../../../definitions/interfaces"
import { iPackage } from "../../../definitions/Package"
import { errorNotification } from "../../../helpers/notificationFunctions"
import { get, handleUpdateData } from "../../../store/data/actions"
import PackagesHeader from "../Header"
import Overview from "./Overview"

const PackageInspector: FunctionComponent<iInspectorProps<iPackage>> = ({
  item,
  reload,
}) => {
  const [isLoading, setLoading] = useState(false)
  const match = useRouteMatch<iIdParams>()
  const methods = useForm<iPackage>({
    defaultValues: { ...item },
    shouldUnregister: false,
  })

  const {
    formState: { dirtyFields },
  } = methods

  const onSubmit = (data: iPackage) => {
    setLoading(true)
    console.log(data)

    handleUpdateData({
      data,
      fields: dirtyFields as Partial<iPackage>,
      link: "/v1/packages/" + item._id,
    })
      .then(() => {
        setLoading(false)
        reload()
        store.addNotification({
          title: "Success!",
          message: "Package successfully updated!",
          type: "success",
          ...notificationOptions,
        })
      })
      .catch((e) => {
        errorNotification(e)
        setLoading(false)
      })
  }

  return (
    <FormProvider {...methods}>
      <Seo title={`${item.name} Package | VR-All-Art`} />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="inspector">
          <form
            onSubmit={methods.handleSubmit((data) => {
              onSubmit(data)
            })}
            className="inspector-form"
          >
            <Route exact path={match.path}>
              <Overview />
            </Route>
          </form>
        </div>
      )}
    </FormProvider>
  )
}

const InspectorLoader: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(true)
  const [access, setAccess] = useState<iAccess>()
  const [item, setItem] = useState<iPackage>()
  const match = useRouteMatch<iIdParams>()
  const history = useHistory()

  const loadPackage = () => {
    Promise.all([
      get<iResponse<iAccess>>({
        link: "/v1/access",
        query: { url: match.params._id, collection: "Packages" },
      }),
      get<iResponse<iPackage>>({
        link: "/v1/packages/" + match.params._id,
      }),
    ])
      .then((result) => {
        const [accessResult, dataResult] = result
        unstable_batchedUpdates(() => {
          setItem(dataResult.data)
          setAccess(accessResult.data)
          setLoading(false)
        })
      })
      .catch((error) => {
        if (error?.status === 403) {
          history.replace("/no-permission")
        }
      })
  }

  useMemo(() => {
    loadPackage()
  }, [])

  return isLoading ? (
    <Loader />
  ) : item && access ? (
    <PackageInspector item={item} access={access} reload={loadPackage} />
  ) : null
}

export default InspectorLoader
